import { render } from "./TheBattleHelp.vue?vue&type=template&id=1c548722&bindings={\"commands\":\"data\",\"description\":\"data\"}"
import script from "./TheBattleHelp.vue?vue&type=script&lang=js"
export * from "./TheBattleHelp.vue?vue&type=script&lang=js"

import "./TheBattleHelp.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script